<template>
  <div>
    <el-row class="warp maincont clear-parent-padding">
      <!-- 头部区域 -->
      <el-col :span="24" class="head">
        <el-row>
          <el-col :span="8" class="warp-breadcrum" style="margin: 20px 0px 0px 10px;">
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
            <el-breadcrumb-item>大屏监控</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
        <el-col :span="8">
          <h1>数据汇聚管理平台</h1>
        </el-col>
        <el-col :span="8">
          <div class="weather">
            <!--<img src="images/weather.png"><span>多云转小雨</span>-->
            <span>{{datetime}}</span>
          </div>
        </el-col>
        </el-row>
      </el-col>
      <!-- 图标区域 -->
      <el-col :span="24" class="warp-main">
        <ul class="clearfix">
          <li class="li1">
            <div class="mbox sm"  style="z-index:90;height:910px;overflow:auto;">
              <a v-for="(item,index) in deviceType" :key="index"  @click="loadOther(item.id+'')" style="cursor:pointer;">
                <div class="iconbox cor0">
                    <!-- <div class="su" v-if="alarmStatistics.fireAlarm > 0">{{alarmStatistics.fireAlarm}}</div> -->
                    <img v-if="item.iconUrl" :src="item.iconUrl" alt="" style="height:30px;width:30px;">
                  </div>
                  <h2 style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.name}}</h2>
              </a>
              
            </div>
          </li>
          <li class="li4">
            <div class="mbox hl">
              <div class="alltitle">设备报警故障统计</div>
              <div class="dafen">
                <div class="sanfen" @click="showDevice({alarmType:'alarm'})" style="cursor:pointer;">
                  <h1>
                    <animate-number from="0" :to="eventStatic.alarm==null?0:eventStatic.alarm" :key="loadTimes"></animate-number>
                  </h1>
                  <h2>报警数</h2>
                </div>
                <div class="sanfen" @click="showDevice({alarmType:'breakdown'})" style="cursor:pointer;">
                  <h1>
                    <animate-number from="0" :to="eventStatic.breakdown==null?0:eventStatic.breakdown" :key="loadTimes"></animate-number>
                  </h1>
                  <h2>故障数</h2>
                </div>
                <div class="sanfen" @click="showDevice({})" style="cursor:pointer;">
                  <h1>
                    <animate-number from="0" :to="eventStatic.device==null?0:eventStatic.device" :key="loadTimes"></animate-number>
                  </h1>
                  <h2>设备总数</h2>
                </div>
              </div>
            </div>
            <div class="mbox hl" style="left:20px;">
              <div class="alltitle">设备状态统计</div>
              <div class="dafen">
                <div class="sanfen" @click="showDevice({stateType:1})" style="cursor:pointer;">
                  <h1 style="color: green;">
                    <animate-number from="0" :to="deviceStateStatic.online==null?0:deviceStateStatic.online" :key="loadTimes"></animate-number>
                  </h1>
                  <h2><i data-v-afc86c0c="" aria-hidden="true" class="fa fa-circle" style="color: green;"></i> 在线</h2>
                </div>
                <div class="sanfen" @click="showDevice({stateType:2})" style="cursor:pointer;">
                  <h1  style="color: red;">
                    <animate-number from="0" :to="deviceStateStatic.unline==null?0:deviceStateStatic.unline" :key="loadTimes"></animate-number>
                  </h1>
                  <h2><i data-v-afc86c0c="" aria-hidden="true" class="fa fa-circle" style="color: red;"></i> 离线</h2>
                </div>
                <div class="sanfen" @click="showDevice({stateType:0})" style="cursor:pointer;">
                  <h1 style="color: yellow;">
                    <animate-number from="0" :to="deviceStateStatic.unknow==null?0:deviceStateStatic.unknow" :key="loadTimes"></animate-number>
                  </h1>
                  <h2><i data-v-afc86c0c="" aria-hidden="true" class="fa fa-circle" style="color: yellow;"></i> 未知</h2>
                </div>
              </div>
            </div>
            <div class="mbox max" style="height: 48em">
              <div class="shuju">
                <ul>
                  <li v-for="(item,index) in newDeviceEvent" :key="index" >
                    <div class="sone">
                      <span>{{item.happenTime}}</span>
                      <a href="">{{item.eventName}}</a>
                    </div>
                    <p>设备号：{{item.deviceCode}}</p>
                    <p>告警值：{{item.eventValue}}</p>
                    <p>{{item.address}}</p>
                  </li>
                </ul>
              </div>
              <div class="map">
                <div class="map1"><img src="../assets/images/lbx.png"></div>
                <div class="map2"><img src="../assets/images/jt.png"></div>
                <div class="map3"><img src="../assets/images/map.png"></div>
                <div class="map4" id="echart-china"></div>
              </div>
            </div>
          </li>
          <li class="li5">
            <div class="mbox max" style="height: 18em">
              <div class="alltitle">设备报警故障明细</div>
              <table border="0" cellspacing="0" class="mtab">
                <thead>
                  <tr>
                    <th  style="width:40%">设备类型</th>
                    <th  style="width:20%">报警</th>
                    <th  style="width:20%">故障</th>
                    <th  style="width:20%">总数</th>
                  </tr>
                </thead>
              </table>
              <div style="height:13rem;width:100%;overflow:auto;">
                <table  border="0" cellspacing="0" class="mtab"> 
                  <tbody>
                    <tr v-for="(item,index) in deviceEventStatic" :key="index" >
                      <td style="width:40%">{{item.type}}</td>
                      <td style="width:20%"><animate-number from="0" :to="item.alarm" :key="loadTimes"></animate-number></td>
                      <td style="width:20%"><animate-number from="0" :to="item.breakdown" :key="loadTimes"></animate-number></td>
                      <td style="width:20%"><animate-number from="0" :to="item.device" :key="loadTimes"></animate-number></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mbox max" style="height: 19rem">
              <div class="alltitle">报警故障处理占比</div>
              <div class="allnav" id="echart5"></div>
              <div class="boxfoot"></div>
            </div>
            <div class="mbox max" style="height: 18rem">
              <div class="alltitle">报警占比</div>
              <div class="allnav" id="echart6"></div>
              <div class="boxfoot"></div>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <!-- 设备 -->
        <el-dialog title="设备详情" :visible.sync="device.visible" :close-on-click-modal="false" style="margin-bottom:20px;">
          <el-row>
            <el-col :span="24" class="toolbar">
              <el-table :data="device.data" highlight-current-row border style="width: 100%;">
                <el-table-column prop="deviceCode" label="设备编号" width="180" align="center" ></el-table-column>
                <el-table-column prop="deviceName" label="设备名称" width="180" align="center"></el-table-column>
                <el-table-column prop="projectName" label="项目" align="center"></el-table-column>
                <el-table-column prop="supplierName" label="设备供应商" align="center"></el-table-column>
              </el-table>
              <el-pagination @size-change="device.handleSizeChange" @current-change="device.handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
                :page-size="device.limit" background layout="total, sizes, prev, pager, next, jumper" :total="device.total" style="float:right;">
              </el-pagination>
            </el-col>
          </el-row>
        </el-dialog>    

        <!-- 项目 -->
        <el-dialog title="项目详情" :visible.sync="project.visible" :close-on-click-modal="false" width="80%">
          <el-row style="margin-bottom:10px;"><el-button type="primary" @click.native="project.openMap">打开地图</el-button></el-row>
          <el-row>
            <el-col :span="24" class="toolbar">
              <el-table :data="project.data" highlight-current-row border style="width: 100%;">
                <el-table-column prop="projectName" label="项目名称" width="200" align="center" show-overflow-tooltip fixed="left" ></el-table-column>
                <el-table-column prop="custName" label="所属企业" width="250" align="center" show-overflow-tooltip ></el-table-column>
                <el-table-column prop="provinceName" label="省" width="160" align="center" ></el-table-column>
                <el-table-column prop="cityName" label="市" width="160" align="center" ></el-table-column>
                <el-table-column prop="districtName" label="区" width="160" align="center" ></el-table-column>
                <el-table-column prop="address" label="项目地址"  align="center" ></el-table-column>
                <el-table-column prop="deviceTotal" label="设备总数" width="100" align="center" ></el-table-column>
              </el-table>
              <el-pagination @size-change="project.handleSizeChange" @current-change="project.handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
                :page-size="project.limit" background layout="total, sizes, prev, pager, next, jumper" :total="project.total" style="float:right;">
              </el-pagination>
            </el-col>
          </el-row>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import echarts from 'echarts';
  import 'echarts/map/js/china';
  import API from "../api/api_screen";
  
  export default {
    data(){
      return {
        timer:null,
        loadTimes:0,
        categoryTypeId:"",
      	datetime: "",
        datetimeTimer: null,
        //数据定时器
        dataTimer: null,
        alarmStatistics: {},//报警故障
        eventStatic:{},//告警报警设备
        deviceStateStatic:{},//设备状态
        newDeviceEvent:[],//最新五条报警故障记录
        echartMap:{
          data:[]
        },
        deviceEventStatic:[],
        ecahrt5:{
          haveHandle:[],
          loading:true,
          noHandle:[]
        },
        echart6:{
          title:[],
          data:[]
        },
        device:{
          visible:false,
          page: 1,
          limit: 10,
          total:0,
          handleSizeChange:function(vl){},
          handleCurrentChange:function(vl){},
          data:[]
        },
        project:{
          visible:false,
          total:0,
          page: 1,
          limit: 10,
          handleSizeChange:function(vl){},
          handleCurrentChange:function(vl){},
          data:[],
          openMap:function(){}
        },
        deviceType:[]
      }
    },
    methods:{
      //查询设备类型
      getDeviceType:function(){
        let that = this;
        API.getDeviceType()
        .then(
          function(result){
            if (result && result.code == 200) {
              console.log(result.data);
              that.deviceType = [{id:'',name:"所有",iconUrl:require('../assets/images/icc_3.png')}].concat(result.data);
            }
          },
          function(error){
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      },
      loadOther:function(param){
        console.log(param);
        let that = this;
        that.categoryTypeId = param;
        that.getDatas(function(){
          that.loadTimes = ++ that.loadTimes;
          that.initEcharts5();
          that.initEcharts6();
          that.initEchartsChina();
        })
      },
      loadDevice:function(params){
        let that = this;
        //查询数据加载
        let requestP =Object.assign({
          page: that.device.page,
          limit: that.device.limit,
          categoryTypeId:that.categoryTypeId
        },params);
        console.log(requestP);
        API.getDeviceList(requestP)
        .then(
          function(result){
            if (result && result.code == 200) {
              that.device.total = result.data.total;
              that.device.data = result.data.records;
            }
          },
          function(error){
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      },
      //显示设备
      showDevice:function(params){
        let that  = this;
        that.device.visible=true;
        that.device.total = 0;
        that.device.limit=10;
        that.device.page=1;
        that.device.data = [];
        that.device.handleSizeChange=function(vl){
          that.device.limit = vl;
          that.loadDevice(params);
        },
        that.device.handleCurrentChange=function(vl){
          that.device.page = vl;
          that.loadDevice(params);
        }
        that.loadDevice(params);
      },
      loadProject:function(params){
        let that  = this;
        //查询数据加载
        let requestP ={
          page: that.project.page,
          limit: that.project.limit,
          provinceName:params.name
        }
        API.getProjectDeviceTotal(requestP)
        .then(
          function(result){
            if (result && result.code == 200) {
              that.project.total = result.data.total;
              that.project.data = result.data.records;
            }
          },
          function(error){
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      },
      //显示项目
      showProject:function(params){
        console.log(params);
        let that = this;
        that.project.total = 0;
        that.project.limit=10;
        that.project.page=1;
        that.project.data = [];
        that.project.visible=true;
        that.project.handleSizeChange=function(vl){
          that.project.limit = vl;
          that.loadProject(params);
        },
        that.project.handleCurrentChange=function(vl){
          that.project.page = vl;
          that.loadProject(params);
        }
        //绑定打开地图
        that.project.openMap=function(){
          that.$router.push({path: '/device/deviceMap',query: {province:params.name}})
        }
        that.loadProject(params);
      },
      getDatas: function(callback){
        let that = this;
        
        API.datas({categoryId:that.categoryTypeId})
        .then(
          function(result){
            if (result && result.code == 200) {
              //去除缓存数据
              that.newDeviceEvent=[];
              that.echartMap={
                data:[]
              },
              that.deviceEventStatic=[];
              that.ecahrt5={
                haveHandle:[],
                noHandle:[]
              };
              that.echart6={
                title:[],
                data:[]
              }
              that.eventStatic =[];
              that.deviceStateStatic={};
              //console.log(result.data);
              //报警，故障的告警数量
              result.data.alarmStatistics.forEach(item => {
                that.alarmStatistics[item.alarmType] = item.alarmNum;
              });
              //报警总数居
              result.data.allAlarmTotal.forEach(item=>{
                that.echart6.title.push(item.alarmName);
                that.echart6.data.push( {value: item.alarmNum, name: item.alarmName});
              })
              //console.log(that.echart6);
              //智能烟感故障数
              result.data.deviceEventStatis.forEach(item => {
                 //设备类型告警，故障和总数
                that.deviceEventStatic.push({type:item.typeName,alarm:item.alarmTotal,breakdown:item.breakdownTotal,device:item.deviceTotal});
              });
              //告警数量统计
              result.data.typeEventStatic.forEach(typeitem => {
                that.eventStatic[typeitem.typeCode]= typeitem.total;
              });
              //设备总数
              that.eventStatic.device=result.data.deviceTotal;
              //设备状态
              that.deviceStateStatic.unknow=0;
              result.data.deviceStateStatic.forEach(item => {
                if(item.deviceStateCode=="1") {that.deviceStateStatic.online= item.total}
                else if(item.deviceStateCode=="2") {that.deviceStateStatic.unline= item.total}
                else {that.deviceStateStatic.unknow= (that.deviceStateStatic.unknow==null?0:that.deviceStateStatic.unknow)+item.total};
              });
              //地图
              result.data.distributes.forEach(item => {
                that.echartMap.data.push({name:item.cityName,value:[item.lng,item.lat,item.total==null?0:item.total]})
              });
              //报警、故障处理未处理
              result.data.handleStatic.forEach(item=>{
                if(item.eventTypeCode=="alarm"){
                  if(item.stateCode=="1"){
                    that.ecahrt5.haveHandle.push(item.total);
                  }else{
                    that.ecahrt5.noHandle.push(item.total);
                  }
                }
                if(item.eventTypeCode=="breakdown")
                {
                  if(item.stateCode=="1"){
                    that.ecahrt5.haveHandle.push[item.total];
                  }else{
                    that.ecahrt5.noHandle.push[item.total];
                  }
                }
                
              });
              //最新告警记录
              that.newDeviceEvent = result.data.newDeviceEvent;
            }
            if (typeof callback === "function"){
              callback(result);
            }
          },
          function(error){
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      },
      initDatas: function(callback) {
        let that = this;
        let timeout = 30000;
        if (that.timer) {
          clearInterval(that.timer);
        }
        that.getDatas(callback);
        that.timer = setInterval(that.getDatas,timeout)
      },
      initDatetime: function(){
      	let that = this;
        this.datetimeTimer = setTimeout(time, 1000); 
        function time() {
          clearTimeout(that.datetimeTimer); 
          let date = new Date();
          let y = date.getFullYear();
          let mt = date.getMonth() + 1;
          let day = date.getDate();
          let h = date.getHours(); 
          let m = date.getMinutes(); 
          let s = date.getSeconds(); 
          that.datetime = y + "年" + mt + "月" + day + "日" + h + "时" + m + "分" + s + "秒";
          that.datetimeTimer = setTimeout(time, 1000);  
        }
      },
      initEcharts5: function() {
        let that=this;
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('echart5'));
        let option = {
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          toolbox: {
              feature: {
                  dataView: {show: true, readOnly: false},
              }
          },
          legend: {
              data: ['未处理', '已处理']
          },
          xAxis: [
              {
                  type: 'category',
                  data: ['报警', '故障'],

              }
          ],
          yAxis: [
              {
                  type: 'value',
                  name: '水量',
                  min: 0
              }
          ],
          series: [
              {
                  name: '未处理',
                  type: 'bar',
                  data: that.ecahrt5.noHandle
              },
              {
                  name: '已处理',
                  type: 'bar',
                  data: that.ecahrt5.haveHandle
              }
          ]
        };

        
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        window.addEventListener("resize",function(){
          myChart.resize();
        });
      },
      initEcharts6: function() {
        let that = this;
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('echart6'));
        let option = {
          title: {
              left: 'center'
          },
          tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
              orient: 'vertical',
              left: 'right',
              data:that.echart6.title
          },
          series: [
              {
                  name: '访问来源',
                  type: 'pie',
                  radius: ['50%', '70%'],
                  center: ['50%', '60%'],
                  data: that.echart6.data,
                  emphasis: {
                      itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  }
              }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        myChart .setOption(option,true);
        window.addEventListener("resize",function(){
          myChart.resize();
        });
      },
      initEchartsChina: function() {
        let that=this;
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('echart-china'));
        let option = {
          tooltip : {
            trigger: 'item',
            formatter: function (params) {
              if(typeof(params.value)[2] == "undefined") {
                return params.name + ' : ' + params.value;
              } else {
                return params.name + ' : ' + params.value[2];
              }
            }
          },
          geo: {
            map: 'china',
            label: {
              emphasis: {
                show: false
              }
            },
            roam: false,//禁止其放大缩小
            layoutSize:200,
            itemStyle: {
              normal: {
                areaColor: '#4c60ff',
                borderColor: '#002097'
              },
              emphasis: {
                areaColor: '#293fff'
              }
            }
          },
          series: [
            {
              name: '',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: that.echartMap.data,
              symbolSize: function (val) {
                return val[2] / 15;
              },
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'center',
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  color: '#ffeb7b'
                }
              }
            },
          ]
        };
        myChart.setOption(option);
        myChart.on('click', function (params) {
          that.showProject(params);
170     });
        window.addEventListener("resize",function(){
          myChart.resize();
        });
      }
      // TOADD
    },
    mounted() {
      let that = this;
      this.initDatetime();
      this.initDatas(function(){
        that.loadTimes =1;
        that.initEcharts5();
        that.initEcharts6();
        that.initEchartsChina();
      });
      this.getDeviceType();
    },
    beforeDestroy() {
       if (this.timer) {
          clearInterval(this.timer);
        }
      if (this.datetimeTimer) {
        clearTimeout(this.datetimeTimer);
      }
      if (this.dataTimer) {
        clearTimeout(this.dataTimer);
      }
    }
  }
</script>
<style scoped>
  @import "../assets/css/screen.css";
  ::-webkit-scrollbar {
    width: 0px;
    height: 5px;
    position: absolute;
  }
  .infinite-list-wrapper{
    height:300px;
    overflow: auto;
  }

  .infinite-list-wrapper .list{
    padding: 0;
    margin: 0;
    list-style: none;
    width:100%;
  }
  
  .infinite-list-wrapper .list-item{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background: #fff6f6;
    color: #ff8484;
    margin-bottom:5px;
  }
  
</style>



// WEBPACK FOOTER //
// screen.vue?da1394da